class PrimaryNavigationDropdown {

    constructor(toggleButton) {

        this.el = toggleButton;
        this.target = document.querySelector(toggleButton.dataset.target);

        if (!this.target) {
            throw new Error("A target is missing");
        }

        this.open = false;
        this.el.onclick = this.toggle.bind(this);
    }

    toggle() {
        if (this.open) {
            this.target.classList.remove('open');
            this.open = false;
        } else {
            this.target.classList.add('open');
            this.open = true;
        }
    }

}

const dropdown = document.querySelector('[data-action="navigation-toggle"]');

if (dropdown) {
    window.primaryNavigationDropdown = new PrimaryNavigationDropdown(dropdown);
}

export default PrimaryNavigationDropdown;